import { ASSETS } from "../lib/constants";

const scenarios = [
  {
    title: "Badkamerraam",
    from: "Van inkijk",
    to: "naar privacy",
    image: ASSETS.homeBeforeAfter,
  },
  {
    title: "Vergaderruimte",
    from: "Van open",
    to: "naar discreet",
    image: ASSETS.privacy,
  },
  {
    title: "Winkelraam",
    from: "Van leeg glas",
    to: "naar advertentieruimte",
    image: ASSETS.led,
  },
];

export default function BeforeAfter() {
  return (
    <section
      id="voordelen"
      className="relative py-24 md:py-32 bg-black/30"
      data-testid="before-after-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-3xl mb-16">
          <div className="text-xs font-bold uppercase tracking-[0.25em] text-cyan-400 mb-4">
            Transformatie
          </div>
          <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-light text-white tracking-tight">
            Een ruimte verandert pas écht wanneer je{" "}
            <span
              className="italic font-medium"
              style={{ color: "#00E5FF" }}
            >
              oppervlak
            </span>{" "}
            meewerkt.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-5 md:gap-6">
          {scenarios.map((s, i) => (
            <div
              key={s.title}
              className="relative rounded-3xl overflow-hidden border border-white/10 group"
              data-testid={`before-after-card-${i}`}
            >
              <div className="aspect-[4/5] overflow-hidden">
                <img
                  src={s.image}
                  alt={s.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div
                className="absolute inset-0"
                style={{
                  background:
                    "linear-gradient(180deg, transparent 35%, rgba(0,0,0,0.9) 100%)",
                }}
              />
              <div className="absolute inset-x-0 bottom-0 p-6 md:p-7">
                <div className="text-[11px] font-bold uppercase tracking-[0.25em] text-cyan-400 mb-2">
                  {s.title}
                </div>
                <h3 className="font-heading text-xl md:text-2xl text-white font-medium leading-tight">
                  {s.from}
                  <br />
                  <span style={{ color: "#C5A059" }}>{s.to}</span>
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
